import { pushToGa4 } from "./pushToDataLayer";

const setGAEvents = () => {
    const pushToDataLayerMap = [
        {
            "selector": "#x-forgot-domain",
            "eventGa4": {
                "eventName": "click_forgot_password",
                "eventOption1": "advertiser integrations",
                "eventOption2": "shopify",
                "eventOption4": "undefined"
            }
        }
    ];

    pushToDataLayerMap.forEach(
        function( data ) {
            const values = document.querySelectorAll(data.selector);
            values.forEach(value => value.addEventListener("click", async (event) => {
                if (data.eventGa4 !== undefined) {
                    pushToGa4(
                        data.eventGa4.eventName,
                        data.eventGa4.eventOption1,
                        data.eventGa4.eventOption2,
                        data.eventGa4.eventOption4
                    );
                }
            }));
        }
    );
}

export default setGAEvents;
